import { Label } from '@/components/ui/label';

const REASON_CLASS =
  'border-input bg-background focus-visible:ring-ring w-full rounded-md border px-2 py-1.5 text-xs focus-visible:ring-2 focus-visible:outline-none';

/** The required reason for saving an order; kept in the audit log with the change. */
export function OrderReason({
  id,
  value,
  onChange,
}: {
  id: string;
  value: string;
  onChange: (value: string) => void;
}) {
  return (
    <div className="space-y-1.5">
      <Label htmlFor={id} className="text-xs">
        Reason <span className="text-muted-foreground font-normal">(required)</span>
      </Label>
      <textarea
        id={id}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        rows={2}
        maxLength={500}
        className={REASON_CLASS}
      />
    </div>
  );
}
